import {FC, useState} from 'react';
import {useBackend} from 'state/backend';
import {Backend} from 'types/api';

import PageEnterprise from './Enterprise';
import PageIndividual from './Individual';
import PageOrganization from './Organization';
import {
    BillingPlanIntegrationsPriceList,
    BillingPlanOptionsPriceList,
    BillingScreenName,
    TermOptions,
} from './types';

export type BillingChangeSubscriptionInitialData = Backend<{
    enterprise: {
        integrationsPrices: BillingPlanIntegrationsPriceList;
        optionPrices: BillingPlanOptionsPriceList;
        sendingOrderCount: number;
    };
    organization: {
        integrationsPrices: BillingPlanIntegrationsPriceList;
        optionPrices: BillingPlanOptionsPriceList;
    };
    termOptions: TermOptions;
}>;

export type BillingChangeSubscriptionProps = {
    isAuthenticated: boolean;
    onSuccess: (url: string) => void;
};

const PlanChange: FC<BillingChangeSubscriptionProps> = ({
    isAuthenticated,
    onSuccess,
}) => {
    const {
        data: {enterprise, organization, termOptions},
    } = useBackend<BillingChangeSubscriptionInitialData>();

    const [screen, setScreen] = useState<BillingScreenName>('individual');

    if (screen === 'organization') {
        return (
            <PageOrganization
                integrationsPrices={organization.integrationsPrices}
                isAuthenticated={isAuthenticated}
                onSuccess={onSuccess}
                onTabChange={setScreen}
                optionPrices={organization.optionPrices}
                termOptions={termOptions}
            />
        );
    }

    if (screen === 'enterprise') {
        return (
            <PageEnterprise
                integrationsPrices={enterprise.integrationsPrices}
                isAuthenticated={isAuthenticated}
                onSuccess={onSuccess}
                onTabChange={setScreen}
                optionPrices={enterprise.optionPrices}
                sendingOrderCount={enterprise.sendingOrderCount}
                termOptions={termOptions}
            />
        );
    }

    return (
        <PageIndividual
            isAuthenticated={isAuthenticated}
            onSuccess={onSuccess}
            onTabChange={setScreen}
            termOptions={termOptions}
        />
    );
};

export default PlanChange;
